import { BreedModel, IBreedModel } from '@common/models/BreedModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class BreedService {
  private static baseUrl: string = '/api/breed';

  static tags = {
    upsertBreed: 'upsertBreed',
    deleteBreed: 'deleteBreed',
  };

  static upsertBreed = (
    data: IBreedModel,
    options?: ServiceMethodOptions,
  ): Promise<BreedModel> => {
    return trackPromise(
      new Promise<BreedModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IBreedModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Breed updated.', options);
            resolve(new BreedModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Breed.', options);
            reject(err);
          });
      }),
      this.tags.upsertBreed,
    );
  };

  static deleteBreed = (
    breedId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${breedId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Breed has been deleted.', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Breed.', options);
            reject(err);
          });
      }),
      this.tags.deleteBreed,
    );
  };
}
